var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildClientRulesMap, getClientPropertyValue, } from "ah_utility/fnxUtils";
import { CalendarPicker } from "@affinitysystemsgroup/assurehub-ui";
var BILLING_CALENDAR_TYPE_PROPERTY = "BILLING_TYPE_CALENDAR";
var DEFAULT_CALENDAR_PICKER = CalendarPicker.Date;
var BILLING_MONTH_MAX_OFFSET_PROPERTY = "BILLING_MONTH_MAX_OFFSET";
var DEFAULT_MONTH_MAX_OFFSET = 1;
export var ALL_BILLING_OPTION_KEYS = [
    "filePerProduct",
    "noCancelPolicy",
    "noExpiredPolicyAge",
];
export var ALL_BILLING_FIELD_KEYS = [
    "maxPeriods",
    "cancelAfterMonths",
    "maxInvoices",
];
var DEFAULT_BILLING_RULES = {
    hiddenBillingTypes: [],
    hiddenOptions: [],
    hiddenFields: [],
    disabledOptions: [],
    disabledFields: [],
};
export var BILLING_TYPE_RULE_PROPERTIES = {
    GENERAL: "BILLING_SHOW_GENERAL",
    NEW: "BILLING_SHOW_NEW_CHARGES",
    REBILLING: "BILLING_SHOW_REBILLING_ONLY",
};
export var BILLING_OPTION_RULE_PROPERTIES = {
    filePerProduct: "BILLING_SHOW_FILE_PER_PRODUCT",
    noCancelPolicy: "BILLING_SHOW_NO_CANCEL_POLICY",
    noExpiredPolicyAge: "BILLING_SHOW_NO_EXPIRED_POLICY_AGE",
};
export var BILLING_FIELD_RULE_PROPERTIES = {
    maxPeriods: "BILLING_SHOW_MAX_PERIODS",
    cancelAfterMonths: "BILLING_SHOW_CANCEL_AFTER",
    maxInvoices: "BILLING_SHOW_MAX_INVOICES",
};
var BILLING_RULE_PROPERTIES = __assign(__assign(__assign({}, BILLING_TYPE_RULE_PROPERTIES), BILLING_OPTION_RULE_PROPERTIES), BILLING_FIELD_RULE_PROPERTIES);
export var BILLING_OPTION_DISABLED_PROPERTIES = {
    filePerProduct: "BILLING_DISABLED_FILE_PER_PRODUCT",
    noCancelPolicy: "BILLING_DISABLED_NO_CANCEL_POLICY",
    noExpiredPolicyAge: "BILLING_DISABLED_NO_EXPIRED_POLICY_AGE",
};
export var BILLING_FIELD_DISABLED_PROPERTIES = {
    maxPeriods: "BILLING_DISABLED_MAX_PERIODS",
    cancelAfterMonths: "BILLING_DISABLED_CANCEL_AFTER",
    maxInvoices: "BILLING_DISABLED_MAX_INVOICES",
};
var BILLING_DISABLED_PROPERTIES = __assign(__assign({}, BILLING_OPTION_DISABLED_PROPERTIES), BILLING_FIELD_DISABLED_PROPERTIES);
export var buildBillingRulesConfig = function (properties, clientId) {
    if (!clientId)
        return DEFAULT_BILLING_RULES;
    var visibleByKey = buildClientRulesMap(properties, clientId, BILLING_RULE_PROPERTIES);
    var disabledRuleByKey = buildClientRulesMap(properties, clientId, BILLING_DISABLED_PROPERTIES, false);
    var hiddenBillingTypes = Object.keys(BILLING_TYPE_RULE_PROPERTIES).filter(function (billingType) { return !visibleByKey[billingType]; });
    var hiddenOptions = Object.keys(BILLING_OPTION_RULE_PROPERTIES).filter(function (option) { return !visibleByKey[option]; });
    var hiddenFields = Object.keys(BILLING_FIELD_RULE_PROPERTIES).filter(function (field) { return !visibleByKey[field]; });
    var disabledOptions = Object.keys(BILLING_OPTION_DISABLED_PROPERTIES).filter(function (option) { return disabledRuleByKey[option]; });
    var disabledFields = Object.keys(BILLING_FIELD_DISABLED_PROPERTIES).filter(function (field) { return disabledRuleByKey[field]; });
    return {
        hiddenBillingTypes: hiddenBillingTypes,
        hiddenOptions: hiddenOptions,
        hiddenFields: hiddenFields,
        disabledOptions: disabledOptions,
        disabledFields: disabledFields,
    };
};
export var getBillingCalendarPicker = function (properties, clientId) {
    if (!clientId)
        return DEFAULT_CALENDAR_PICKER;
    var rawValue = getClientPropertyValue(properties, clientId, BILLING_CALENDAR_TYPE_PROPERTY);
    return rawValue === "MONTH" ? CalendarPicker.Month : DEFAULT_CALENDAR_PICKER;
};
export var getBillingMonthMaxOffset = function (properties, clientId) {
    if (!clientId)
        return DEFAULT_MONTH_MAX_OFFSET;
    var rawValue = getClientPropertyValue(properties, clientId, BILLING_MONTH_MAX_OFFSET_PROPERTY);
    var parsedOffset = rawValue ? parseInt(rawValue, 10) : NaN;
    return Number.isFinite(parsedOffset) && parsedOffset > 0
        ? parsedOffset
        : DEFAULT_MONTH_MAX_OFFSET;
};
var BILLING_FIELD_OPTIONS_PROPERTIES = {
    maxPeriods: "BILLING_MAX_PERIODS_OPTIONS",
    cancelAfterMonths: "BILLING_CANCEL_AFTER_OPTIONS",
    maxInvoices: "BILLING_MAX_INVOICES_OPTIONS",
};
var BILLING_FIELD_DEFAULT_PROPERTIES = {
    maxPeriods: "BILLING_MAX_PERIODS_DEFAULT",
    cancelAfterMonths: "BILLING_CANCEL_AFTER_DEFAULT",
    maxInvoices: "BILLING_MAX_INVOICES_DEFAULT",
};
var FALLBACK_FIELD_OPTIONS = ["1", "2", "3", "4", "5"];
export var FALLBACK_FIELD_VALUES = {
    maxPeriods: "5",
    cancelAfterMonths: "3",
    maxInvoices: "3",
};
var parseFieldOptions = function (rawValue) {
    if (!rawValue)
        return null;
    try {
        var parsed = JSON.parse(rawValue);
        if (!Array.isArray(parsed))
            return null;
        var options = Array.from(new Set(parsed
            .filter(function (item) { return typeof item === "string" || typeof item === "number"; })
            .map(function (item) { return String(item).trim(); })
            .filter(function (item) { return item.length > 0; })));
        return options.length > 0 ? options : null;
    }
    catch (_a) {
        return null;
    }
};
var resolveDefaultValue = function (options, rawDefault, fallback) {
    var _a;
    var candidate = (_a = rawDefault === null || rawDefault === void 0 ? void 0 : rawDefault.trim()) !== null && _a !== void 0 ? _a : "";
    if (options.includes(candidate))
        return candidate;
    return options.includes(fallback) ? fallback : options[0];
};
export var getBillingSelectConfigs = function (properties, clientId) {
    return ALL_BILLING_FIELD_KEYS.reduce(function (configs, field) {
        var _a;
        var _b;
        var options = (_b = parseFieldOptions(getClientPropertyValue(properties, clientId, BILLING_FIELD_OPTIONS_PROPERTIES[field]))) !== null && _b !== void 0 ? _b : FALLBACK_FIELD_OPTIONS;
        var defaultValue = resolveDefaultValue(options, getClientPropertyValue(properties, clientId, BILLING_FIELD_DEFAULT_PROPERTIES[field]), FALLBACK_FIELD_VALUES[field]);
        return __assign(__assign({}, configs), (_a = {}, _a[field] = { options: options, defaultValue: defaultValue }, _a));
    }, {});
};
